<template>
  <div class="page-effect">
    <!-- <div id="websdkready" onclick="websdkready();"></div> -->
    <div id="ZoomEmbeddedApp" @click="generateSignature" style="position:absolute; z-index:9999999;">Join</div>
  </div>
</template>

<script src="@/js/zoomweb/vconsole.min.js"></script>

<script>
// import db from "../components/firebaseInit";
// import APIs from "@/components/APIInit";
// import router from "../router";
// import jQuery from "jquery";
// let $ = jQuery;
import Vue from 'vue';

//Vue.prototype.ZoomMtg = window.ZoomMtg;
// For Component View
//Vue.prototype.ZoomMtgEmbedded = window.ZoomMtgEmbedded;

var vm;
export default {
  data() {
    return {
      client: this.ZoomMtgEmbedded.createClient(),
      tk: "CCJ694andfRgzTKsq7osEjuwYWTgIYExibDZwPeqcE0.DQMAAAAWkSRd1hZ0XzNEUHhFYlJZQ3pYcktudEw5UGdRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
      meetingNumber: "96924360150",
      apiKey: "hCamgU8QRI6a3LUm9y31vQ",
      apiSecret: "iY6mvWQld5RZU4dpltW2SW3XkNdopGrIMKCv",
      role: 0,
      userName: "Debashis",
      passWord: "rb1234",
      userEmail: "debayanghosh@webspiders.com",
      signature: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();
    //vm.ImportExternalJS();
    // setTimeout(() => {
    //   // var testTool = window.testTool;
    //   // console.log(testTool);
    //   debugger;
    //   //vm.websdkready();
    //   //vm.generateSignature();
    //   //vm.beginJoin();
    // }, 10000);
  },
  methods: {
    beginJoin() {
      debugger;
      //var rootElement = document.getElementById("ZoomEmbeddedApp");
      var rootElement = document.getElementById("zmmtg-root");
        //zoomAppRoot: rootElement,
      vm.client.init({
        disablePreview: true,
        leaveUrl: "/zoom-web",//"https://ws.e2m.live", //meetingConfig.leaveUrl,
        webEndpoint: undefined,//"zoom.us", //meetingConfig.webEndpoint,
        disableCORP: !window.crossOriginIsolated, // default true
        // disablePreview: false, // default false
        success: function () {
          debugger;
          //alert(meetingConfig.tk)
          //console.log(meetingConfig);
          //console.log("signature", signature);
          // ZoomMtgEmbedded.i18n.load(meetingConfig.lang);
          // ZoomMtgEmbedded.i18n.reload(meetingConfig.lang);
          ZoomMtgEmbedded.i18n.load("en-US");
          ZoomMtgEmbedded.i18n.reload("en-US");
          if (vm.tk) {
            debugger;
            ZoomMtgEmbedded.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              tk: vm.tk,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtgEmbedded.getAttendeeslist({});
                ZoomMtgEmbedded.getCurrentUser({
                  success: function (res) {
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          } else {
            debugger;
            ZoomMtgEmbedded.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtgEmbedded.getAttendeeslist({});
                ZoomMtgEmbedded.getCurrentUser({
                  success: function (res) {
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          }
        },
        error: function (res) {
          debugger;
          console.log(res);
        },
      });

      ZoomMtgEmbedded.inMeetingServiceListener("onUserJoin", function (data) {
        debugger;
        console.log("inMeetingServiceListener onUserJoin", data);
      });

      ZoomMtgEmbedded.inMeetingServiceListener("onUserLeave", function (data) {
        alert("");
        debugger;
        console.log("inMeetingServiceListener onUserLeave", data);
      });

      ZoomMtgEmbedded.inMeetingServiceListener(
        "onUserIsInWaitingRoom",
        function (data) {
          debugger;
          console.log("inMeetingServiceListener onUserIsInWaitingRoom", data);
        }
      );

      ZoomMtgEmbedded.inMeetingServiceListener("onMeetingStatus", function (data) {
        debugger;
        console.log("inMeetingServiceListener onMeetingStatus", data);
      });
    },
    generateSignature() {
      debugger;
      // ZoomMtgEmbedded.preLoadWasm();
      // ZoomMtgEmbedded.prepareJssdk();
      client.generateSignature({
        meetingNumber: vm.meetingNumber,
        apiKey: vm.apiKey,
        apiSecret: vm.apiSecret,
        role: vm.role,
        success: function (res) {
          debugger;
          vm.signature = res.result;

          vm.beginJoin();
          // console.log(res.result);
          // meetingConfig.signature = res.result;
          // meetingConfig.apiKey = API_KEY;
          // var joinUrl = "/meeting.html?" + testTool.serialize(meetingConfig);
          // console.log(joinUrl);
          // location.href = joinUrl;
          // //window.open(joinUrl, "_blank");
        },
      });
    },
    beginJoin1() {
      debugger;
      ZoomMtgEmbedded.preLoadWasm();
      ZoomMtgEmbedded.prepareJssdk();
      //var rootElement = document.getElementById("ZoomEmbeddedApp");
      var rootElement = document.getElementById("zmmtg-root");
        //zoomAppRoot: rootElement,
      ZoomMtgEmbedded.init({
        disablePreview: true,
        leaveUrl: "/zoom-web",//"https://ws.e2m.live", //meetingConfig.leaveUrl,
        webEndpoint: undefined,//"zoom.us", //meetingConfig.webEndpoint,
        disableCORP: !window.crossOriginIsolated, // default true
        // disablePreview: false, // default false
        success: function () {
          debugger;
          //alert(meetingConfig.tk)
          //console.log(meetingConfig);
          //console.log("signature", signature);
          // ZoomMtgEmbedded.i18n.load(meetingConfig.lang);
          // ZoomMtgEmbedded.i18n.reload(meetingConfig.lang);
          ZoomMtgEmbedded.i18n.load("en-US");
          ZoomMtgEmbedded.i18n.reload("en-US");
          if (vm.tk) {
            debugger;
            ZoomMtgEmbedded.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              tk: vm.tk,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtgEmbedded.getAttendeeslist({});
                ZoomMtgEmbedded.getCurrentUser({
                  success: function (res) {
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          } else {
            debugger;
            ZoomMtgEmbedded.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtgEmbedded.getAttendeeslist({});
                ZoomMtgEmbedded.getCurrentUser({
                  success: function (res) {
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          }
        },
        error: function (res) {
          debugger;
          console.log(res);
        },
      });

      ZoomMtgEmbedded.inMeetingServiceListener("onUserJoin", function (data) {
        debugger;
        console.log("inMeetingServiceListener onUserJoin", data);
      });

      ZoomMtgEmbedded.inMeetingServiceListener("onUserLeave", function (data) {
        alert("");
        debugger;
        console.log("inMeetingServiceListener onUserLeave", data);
      });

      ZoomMtgEmbedded.inMeetingServiceListener(
        "onUserIsInWaitingRoom",
        function (data) {
          debugger;
          console.log("inMeetingServiceListener onUserIsInWaitingRoom", data);
        }
      );

      ZoomMtgEmbedded.inMeetingServiceListener("onMeetingStatus", function (data) {
        debugger;
        console.log("inMeetingServiceListener onMeetingStatus", data);
      });
    },
    generateSignature1() {
      debugger;
      ZoomMtgEmbedded.preLoadWasm();
      ZoomMtgEmbedded.prepareJssdk();
      ZoomMtgEmbedded.generateSignature({
        meetingNumber: vm.meetingNumber,
        apiKey: vm.apiKey,
        apiSecret: vm.apiSecret,
        role: vm.role,
        success: function (res) {
          debugger;
          vm.signature = res.result;

          vm.beginJoin();
          // console.log(res.result);
          // meetingConfig.signature = res.result;
          // meetingConfig.apiKey = API_KEY;
          // var joinUrl = "/meeting.html?" + testTool.serialize(meetingConfig);
          // console.log(joinUrl);
          // location.href = joinUrl;
          // //window.open(joinUrl, "_blank");
        },
      });
    },
  },
};
</script>